export const environment = {
	production: true,
	bff: {
		baseUrl: 'http://localhost:3000',
	},
	charon: {
		id: 'qvjzobwp',
		entrypoint: 'https://apicd.cloud.itau.com.br/charon/qvjzobwp',
		cryptographyUrl: `https://caronte.cyberdefense.prod.aws.cloud.ihf/iske`,
		itauApiKey: 'IOeVWbJJ70aZCnLXBigo',
	},
	featureToggles: {
		charon: true,
	},
};
